import React, { useState } from 'react';
import { motion } from 'framer-motion';
import copy from 'copy-to-clipboard';
import Layout from '../components/Layout';
import Textarea from '../components/Textarea';
import Button from '../components/Button';
import { generateLoremIpsum } from '../utils/textUtils';

const LoremIpsum: React.FC = () => {
  const [paragraphs, setParagraphs] = useState(3);
  const [result, setResult] = useState('');
  const [showToast, setShowToast] = useState(false);

  const handleGenerate = (count?: number) => {
    const finalCount = count !== undefined ? count : paragraphs;
    const text = generateLoremIpsum(finalCount);
    setResult(text);
  };

  const handleCopy = () => {
    copy(result);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 2000);
  };

  return (
    <Layout showBackButton>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="mb-32"
        >
          <h1 className="text-4xl font-bold text-textPrimary mb-8">
            더미 텍스트 생성
          </h1>
          <p className="text-textSecondary">
            디자인 목업용 샘플 텍스트
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="mb-24"
        >
          <label className="block text-textSecondary mb-12 text-sm font-semibold">
            생성할 양 선택
          </label>
          <div className="flex flex-wrap gap-12 mb-24">
            <Button onClick={() => handleGenerate(1)}>1 문단</Button>
            <Button onClick={() => handleGenerate(3)}>3 문단</Button>
            <Button onClick={() => handleGenerate(5)}>5 문단</Button>
          </div>

          <div className="mb-24">
            <label className="block text-textSecondary mb-8 text-sm">
              또는 직접 입력
            </label>
            <div className="flex gap-12 items-center">
              <input
                type="number"
                value={paragraphs}
                onChange={(e) => setParagraphs(parseInt(e.target.value) || 1)}
                min="1"
                max="20"
                className="px-16 py-12 border border-border rounded-medium w-32 focus:outline-none focus:ring-2 focus:ring-primary"
              />
              <span className="text-textSecondary">문단</span>
              <Button onClick={() => handleGenerate()}>생성하기</Button>
            </div>
          </div>
        </motion.div>

        {result && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="mb-24"
          >
            <label className="block text-textSecondary mb-8 text-sm">
              생성된 텍스트
            </label>
            <Textarea value={result} onChange={setResult} minHeight="400px" />
            <div className="mt-12">
              <Button onClick={handleCopy}>결과 복사</Button>
            </div>
          </motion.div>
        )}

        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            className="fixed bottom-32 left-1/2 transform -translate-x-1/2 bg-textPrimary text-white px-24 py-12 rounded-medium shadow-lg"
          >
            ✓ 복사됨
          </motion.div>
        )}
      </div>
    </Layout>
  );
};

export default LoremIpsum;
